module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-1.c70311a0.png";